export default function getValueOrUndefined(object: any, ...path: any[]): any {
  if (typeof object !== "undefined" && path.length) {
    const key = path.shift();

    return getValueOrUndefined(object[key], ...path);
  } else {
    return object;
  }
}
